import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormItem } from '@/components';
import { Input } from '@/ui';
import { IPartnerProfile } from '@/models/partners.model';

import { PartnerFormFieldsNames } from '../../helpers/types';
import { usePartnerFormRules } from '../../hooks';
import { BankAccountRow } from './BankAccountsFieldsStyles';

interface IBankAccountsFields {
  isNew?: boolean;
  initialValues?: IPartnerProfile | null;
}

const BankAccountsFields = ({ isNew = false }: IBankAccountsFields) => {
  const { t } = useTranslation('partners');
  const rules = usePartnerFormRules();
  const requiredRule = rules[PartnerFormFieldsNames.TITLE][0];

  return (
    <>
      <BankAccountRow $isNew={isNew}>
        <FormItem
          name={PartnerFormFieldsNames.BANK_NAME}
          label={t('partners_bank_name')}
          required
          rules={[requiredRule]}
        >
          <Input />
        </FormItem>

        <FormItem
          name={['bankAccountsDraft', 'primaryMfo']}
          label={t('partners_mfo')}
          required
          rules={[
            requiredRule,
            {
              pattern: /^\d{6}$/,
              message: t('partners_mfo_invalid'),
            },
          ]}
        >
          <Input inputMode="numeric" maxLength={6} />
        </FormItem>
      </BankAccountRow>

      <FormItem
        name={PartnerFormFieldsNames.IBAN}
        label={t('partners_iban')}
        required
        rules={[
          requiredRule,
          {
            pattern: /^UA\d{27}$/,
            message: t('partners_iban_invalid'),
          },
        ]}
      >
        <Input maxLength={29} />
      </FormItem>
    </>
  );
};

export default BankAccountsFields;
